import { useEffect } from "react";
import { DocumentRenderer } from "../components/DocumentRenderer";

interface Props {
  content: string;
  scrollTo?: string;
}

export function DocumentPage({ content, scrollTo }: Props) {
  useEffect(() => {
    if (scrollTo) {
      const timer = setTimeout(() => {
        const el = document.getElementById(scrollTo);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 150);
      return () => clearTimeout(timer);
    } else {
      window.scrollTo(0, 0);
    }
  }, [scrollTo, content]);

  return (
    <main className="flex-1 pt-20 bg-slate-50 dark:bg-[#070b12] min-h-screen transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white dark:bg-[#0e1724] border border-slate-200 dark:border-slate-800 rounded-2xl p-6 sm:p-10 shadow-sm doc-section transition-colors">
          <DocumentRenderer content={content} />
        </div>
      </div>
    </main>
  );
}
